// updateService.js

import { Capacitor } from '@capacitor/core';
import packageJson from '../../package.json';

const API_BASE_URL = `${process.env.REACT_APP_BACKEND}/astro`;

// Helper function to compare semantic versions
const compareVersions = (v1, v2) => {
  const parts1 = v1.split('.').map(Number);
  const parts2 = v2.split('.').map(Number);
  
  for (let i = 0; i < Math.max(parts1.length, parts2.length); i++) {
    const num1 = parts1[i] || 0;
    const num2 = parts2[i] || 0;
    
    if (num1 > num2) return 1;
    if (num1 < num2) return -1;
  }
  
  return 0;
};

const getCurrentVersion = async () => {
  try {
    if (Capacitor.isNativePlatform()) {
      const { App } = await import('@capacitor/app');
      const appInfo = await App.getInfo();
      return appInfo.version;
    } else {
      return packageJson.version;
    }
  } catch (error) {
    console.error(' Failed to get app version:', error);
    return '1.0.0';
  }
};

const openPlayStore = async (playStoreUrl) => {
  try {
    console.log('🔗 Opening Play Store:', playStoreUrl);
    
    if (Capacitor.isNativePlatform()) {
      const { Browser } = await import('@capacitor/browser');
      await Browser.open({ url: playStoreUrl });
    } else {
      window.open(playStoreUrl, '_blank');
    }
  } catch (error) {
    console.error(' Failed to open Play Store:', error);
    window.open(playStoreUrl, '_blank');
  }
};

/**
 * Check for updates - Returns update info
 */
export const checkForUpdates = async () => {
  try {
    console.log('🔍 Checking for Play Store updates...');
    console.log('🌐 API Base URL:', API_BASE_URL);

    const currentVersion = await getCurrentVersion();
    console.log('📱 Current app version:', currentVersion);

    // Send current version to backend
    const response = await fetch(`${API_BASE_URL}/app-version?version=${currentVersion}`);
    const data = await response.json();
    
    if (!data.success) {
      console.error(' Failed to fetch version info');
      return null;
    }

    console.log('📦 Server response:', data);

    const { 
      updateRequired, 
      mandatory, 
      minimumVersion,
      latestVersion, // For backward compatibility
      playStoreUrl, 
      releaseNotes 
    } = data;

    // Use backend's decision
    if (updateRequired) {
      console.log(`🆕 Update required: ${currentVersion} → ${minimumVersion || latestVersion}`);
      
      return {
        updateAvailable: true,
        currentVersion,
        latestVersion: minimumVersion || latestVersion,
        playStoreUrl,
        mandatory,
        releaseNotes,
        openPlayStore: () => openPlayStore(playStoreUrl)
      };
    } else {
      console.log('App is up to date');
      return null;
    }
  } catch (error) {
    console.error('Update check failed:', error);
    return null;
  }
};
